import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Search, Layout, Link2, Activity } from 'lucide-react';

export const ImplementationSection = () => {
  const steps = [
    {
      icon: Search,
      number: '01',
      title: 'Bedarfsanalyse',
      description: 'Lastanalyse und Dimensionierung',
      color: 'bg-primary',
    },
    {
      icon: Layout,
      number: '02',
      title: 'Systemplanung',
      description: 'Akkuwahl und Sicherheitskonzept',
      color: 'bg-accent',
    },
    {
      icon: Link2,
      number: '03',
      title: 'Integration',
      description: 'Netzanbindung und BMS-Einrichtung',
      color: 'bg-secondary',
    },
    {
      icon: Activity,
      number: '04',
      title: 'Betrieb & Monitoring',
      description: 'Echtzeitsteuerung und Optimierung',
      color: 'bg-success',
    },
  ];

  return (
    <section id="implementation" className="py-12 sm:py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <p className="text-base sm:text-xl text-muted-foreground font-normal mb-2">
              BESS-Implementierung:
            </p>
            <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-primary mb-6">
              Planung, Integration und Betrieb
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              Eine erfolgreiche BESS-Einführung erfordert sorgfältige Planung
              und nahtlose Integration in die bestehende
              Rechenzentrumsinfrastruktur. Der Prozess gliedert sich in vier
              klar definierte Phasen.
            </p>
          </div>

          {/* Timeline */}
          <div className="relative mb-12">
            {/* Connection Line - Hidden on mobile */}
            <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-border" />

            {/* Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 relative">
              {steps.map((step, index) => (
                <Card
                  key={index}
                  className="border-border hover:border-primary/30 transition-all duration-300 hover:shadow-md hover:-translate-y-2 group relative"
                >
                  {/* Step Number Badge */}
                  <div className="absolute -top-4 left-6 z-10">
                    <Badge
                      className={`${step.color} text-primary-foreground text-sm font-heading font-bold px-3 py-1`}
                    >
                      {step.number}
                    </Badge>
                  </div>

                  <CardContent className="p-6 pt-8">
                    {/* Icon */}
                    <div className="w-16 h-16 rounded-xl bg-muted flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                      <step.icon className="w-8 h-8 text-foreground" />
                    </div>

                    {/* Title */}
                    <h3 className="font-heading font-semibold text-xl text-foreground mb-2">
                      {step.title}
                    </h3>

                    {/* Description */}
                    <p className="text-muted-foreground">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Bilder */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <img
              src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/kejr8bls_Stock_Datacenter2.png"
              alt="BESS-Installation – Vor Ort"
              className="w-full rounded-lg shadow-lg object-cover aspect-video"
              loading="lazy"
              data-testid="implementation-image-1"
            />
            <img
              src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/hs4usgtw_Stock_Datacenter5.png"
              alt="Monitoring-System – Live-Ansicht"
              className="w-full rounded-lg shadow-lg object-cover aspect-video"
              loading="lazy"
              data-testid="implementation-image-2"
            />
          </div>
        </div>
      </div>
    </section>
  );
};